





























import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import DishCategory from "@/models/DishCategory";
import dishesService from "@/services/dishes-service";

@Component
export default class DishCategories extends Vue {
  categories: DishCategory[] = [];

  async loadAsync() {
    this.categories = (await dishesService.findAllCategoriesAsync()).items;
  }

  async mounted() {
    await this.loadAsync();
  }
}
